import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';

import Container from 'components/Container';
import { Button } from '@mui/material';

// import pdf1 from 'assests/Pdf/Results/CLASS102021-22NEW.pdf'
// import pdf2 from 'assests/Pdf/Results/CLASS122021-2NEW.pdf'



const Y2022 = () => {
  const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
      fetch('/config.json')
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    const pdf1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Results/CLASS102021-22NEW.pdf`;
    const pdf2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/Results/CLASS122021-2NEW.pdf`;
    const pdf3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/pdf/CCA/INTERSCHOOLPPT22-23.pdf`;


  const theme = useTheme();

  const mock = [
    {
      name: 'RAISING STAR',
      title: 'Click here',
      
      href:pdf1,
    },
    {
      name: 'HUMAN INTREST STORIES',
      title: 'Click here',
     
      href:pdf2,
    },
    {
      name: 'INTER SCHOOL COMPETITION',
      title: 'Click here',
     
      href:pdf3,
    },
  
  ];

  return (
    <Container>
      <Box>
        <Box marginBottom={4}>
          <Typography
            sx={{
              textTransform: 'uppercase',
            }}
            gutterBottom
            color={'text.secondary'}
            align={'center'}
            fontWeight={700}
          >
            Trail of Triumphs 2022
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {mock.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box
                width={1}
                height={1}
                component={Card}
                boxShadow={0}
                variant={'outlined'}
                bgcolor={'alternate.main'}
              >
                <CardContent sx={{ padding: 3 }}>
                  <ListItem component="div" disableGutters sx={{ padding: 0 }}>
                  
                    <Button 
                    href={item.href}>
                    <ListItemText
                      sx={{ margin: 0 }}
                      primary={item.name}
                      secondary={item.title}
                      primaryTypographyProps={{
                        variant: 'h6',
                        fontWeight: 700,
                      }}
                      secondaryTypographyProps={{ variant: 'subtitle1' }}
                    />
                    </Button>
                  </ListItem>
                </CardContent>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Y2022;

